import React, { FC, memo, useMemo, useState } from 'react';
import { FlexBox, useIsMobile, useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {API, Project, ProjectAPI, TeamAPI} from '@brg/api';
import ReactTooltip from "react-tooltip";
import {useGetIsOwner} from "../../../hooks/api/useGetIsOwner";
import {useGetCurrentTeam} from "../../../hooks/useGetCurrentTeam";
import {useGetIsPendingProject} from "../../../hooks/api/useGetIsPendingProject";
import {
    ApprovalDialogWrapper,
    ApprovalTitle,
    ApproveProjectButton,
    CheckBoxWrapper,
    getApprovalFontColor, RadioBox, RadioCircle, RadioInputSource, RadioLabel
} from "./ApprovalDialog";
import {useGetOrganizationEntity} from "../../../hooks/api/useGetOrganizationEntity";
import { useProfile } from '@brg/auth';

const YES = 1;
const NO = 0;

type OrganizationApprovalDialogProps = {
    project: Project;
    onShouldReload?: (project: Project) => void;
    reloadProject?: (time: any) => void;
};

const OrganizationApprovalDialog: FC<OrganizationApprovalDialogProps> = ({
                                                     project: initialProject,
                                                 }) => {
    const isMobile = useIsMobile();
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const profile = useProfile();
    const [selected, setSelected] = useState<number | undefined>();
    const currentTeam = useGetCurrentTeam();
    const [project, setProject] = useState(initialProject);
        //@ts-ignore
    const projectColor = useMemo(() => (project && project?.additionalInfo?.color), [project]);
    const organizationEntity = useGetOrganizationEntity(currentTeam ? currentTeam?.id : '');
    const [isPending, isPendingLoading] = useGetIsPendingProject(organizationEntity.contextName, project?.projectId, i18n.language);
    const toasts = useToasts();
    const [isHidden, setIsHidden] = useState(false);

    // const [isOwner, isOwnerLoading] = useGetIsOwner(currentTeam ? currentTeam?.id : '', i18n.language);

    const isOwner = useMemo(
        () => (profile && organizationEntity?.ownersIDs?.includes(profile?.accountId)) 
    , [currentTeam, profile])

    const handleSubmit = async () => {

        if (!currentTeam) return;

        const params = {teamId: currentTeam?.id, projectIds: [project.projectId]};

        await (selected ? TeamAPI.ApproveProject(params) : TeamAPI.RejectProject(params))
            .then((res) => {
                if (res.status === 200) {
                    toasts.info(selected ? t('project_approved_notification') + currentTeam?.title || '' : t('project_disapproved_notification') + currentTeam?.title);
                    setIsHidden(true);

                }
                if (res.status === 400) {
                    toasts.info(t('can_not_do'));
                }
            }).catch((e) => {
                toasts.info('Ошибка запроса');
            }).finally(() => {
                API.Json(ProjectAPI.Get({ idProject: project.projectId }))
                    //@ts-ignore
                    .then((p) => setProject(p));
            });
    }

    const Radio = (props: any) => {
        return (
            <CheckBoxWrapper disabled={props.disabled}>
                <FlexBox>
                    <RadioInputSource {...props as any} type={'radio'}/>
                    <RadioBox {...props as any}>
                        <RadioCircle {...props as any} />
                        <RadioLabel {...props as any} >
                            {props.title}
                        </RadioLabel>
                    </RadioBox>
                </FlexBox>
            </CheckBoxWrapper>
        )
    }

    if (!isOwner || !currentTeam || !isPending || isHidden) return null;

    return (
        <ApprovalDialogWrapper
            width={'100%'}
            // height={'100%'}
            direction="column"
            align={"center"}
            justify={"center"}
            offsetLeft={!isMobile ? 24 : 0}
            offsetTop={isMobile ? 24 : 0}
            className='org-approval-dialog-wrapper'
        >
            <FlexBox align={"center"} justify={"center"} direction={"row"} gy={0}>
                <ApprovalTitle
                    // isBook={isBook}
                    color={theme.projectView.titleColor}>
                    {t('approve_project_on', {title: currentTeam?.title})}
                </ApprovalTitle>
                <FlexBox>
                    <Radio
                        // disabled={buttonDisabled}
                        // isBook={isBook}
                        onChange={() => setSelected(YES)}
                        name={'approval'}
                        title={t('yes')}
                        checked={selected === YES}
                        clr={getApprovalFontColor(projectColor)}
                    />
                    <Radio
                        // isBook={isBook}
                        // disabled={buttonDisabled}
                        onChange={() => setSelected(NO)}
                        name={'approval'}
                        title={t('no')}
                        checked={selected === NO}
                        clr={getApprovalFontColor(projectColor)}
                    />
                </FlexBox>
                <FlexBox>
                    <div data-tip={'Выберите один из вариантов'}>
                        <ApproveProjectButton
                            // isBook={isBook}
                            onClick={handleSubmit}
                            disabled={false}
                        >
                            {t('save')}
                        </ApproveProjectButton>
                    </div>
                </FlexBox>
            </FlexBox>
            <ReactTooltip/>
        </ApprovalDialogWrapper>
    );
};

export default memo(OrganizationApprovalDialog)
import React, { FC, memo, useMemo, useState } from 'react';
import { FlexBox, useIsMobile, useToasts } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {API, Project, ProjectAPI, TeamAPI} from '@brg/api';
import ReactTooltip from "react-tooltip";
import {useGetIsOwner} from "../../../hooks/api/useGetIsOwner";
import {useGetCurrentTeam} from "../../../hooks/useGetCurrentTeam";
import {useGetIsPendingProject} from "../../../hooks/api/useGetIsPendingProject";
import {
    ApprovalDialogWrapper,
    ApprovalTitle,
    ApproveProjectButton,
    CheckBoxWrapper,
    getApprovalFontColor, RadioBox, RadioCircle, RadioInputSource, RadioLabel
} from "./ApprovalDialog";
import {useGetOrganizationEntity} from "../../../hooks/api/useGetOrganizationEntity";
import { useProfile } from '@brg/auth';

const YES = 1;
const NO = 0;

type OrganizationApprovalDialogProps = {
    project: Project;
    onShouldReload?: (project: Project) => void;
    reloadProject?: (time: any) => void;
};

const OrganizationApprovalDialog: FC<OrganizationApprovalDialogProps> = ({
                                                     project: initialProject,
                                                 }) => {
    const isMobile = useIsMobile();
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const profile = useProfile();
    const [selected, setSelected] = useState<number | undefined>();
    const currentTeam = useGetCurrentTeam();
    const [project, setProject] = useState(initialProject);
        //@ts-ignore
    const projectColor = useMemo(() => (project && project?.additionalInfo?.color), [project]);
    const organizationEntity = useGetOrganizationEntity(currentTeam ? currentTeam?.id : '');
    const [isPending, isPendingLoading] = useGetIsPendingProject(organizationEntity.contextName, project?.projectId, i18n.language);
    const toasts = useToasts();
    const [isHidden, setIsHidden] = useState(false);

    // const [isOwner, isOwnerLoading] = useGetIsOwner(currentTeam ? currentTeam?.id : '', i18n.language);

    const isOwner = useMemo(
        () => (profile && organizationEntity?.ownersIDs?.includes(profile?.accountId)) 
    , [currentTeam, profile])

    const handleSubmit = async () => {

        if (!currentTeam) return;

        const params = {teamId: currentTeam?.id, projectIds: [project.projectId]};

        await (selected ? TeamAPI.ApproveProject(params) : TeamAPI.RejectProject(params))
            .then((res) => {
                if (res.status === 200) {
                    toasts.info(selected ? t('project_approved_notification') + currentTeam?.title || '' : t('project_disapproved_notification') + currentTeam?.title);
                    setIsHidden(true);

                }
                if (res.status === 400) {
                    toasts.info(t('can_not_do'));
                }
            }).catch((e) => {
                toasts.info('Ошибка запроса');
            }).finally(() => {
                API.Json(ProjectAPI.Get({ idProject: project.projectId }))
                    //@ts-ignore
                    .then((p) => setProject(p));
            });
    }

    const Radio = (props: any) => {
        return (
            <CheckBoxWrapper disabled={props.disabled}>
                <FlexBox>
                    <RadioInputSource {...props as any} type={'radio'}/>
                    <RadioBox {...props as any}>
                        <RadioCircle {...props as any} />
                        <RadioLabel {...props as any} >
                            {props.title}
                        </RadioLabel>
                    </RadioBox>
                </FlexBox>
            </CheckBoxWrapper>
        )
    }

    if (!isOwner || !currentTeam || !isPending || isHidden) return null;

    return (
        <ApprovalDialogWrapper
            width={'100%'}
            // height={'100%'}
            direction="column"
            align={"center"}
            justify={"center"}
            offsetLeft={!isMobile ? 24 : 0}
            offsetTop={isMobile ? 24 : 0}
            className='org-approval-dialog-wrapper'
        >
            <FlexBox align={"center"} justify={"center"} direction={"row"} gy={0}>
                <ApprovalTitle
                    // isBook={isBook}
                    color={theme.projectView.titleColor}>
                    {t('approve_project_on', {title: currentTeam?.title})}
                </ApprovalTitle>
                <FlexBox>
                    <Radio
                        // disabled={buttonDisabled}
                        // isBook={isBook}
                        onChange={() => setSelected(YES)}
                        name={'approval'}
                        title={t('yes')}
                        checked={selected === YES}
                        clr={getApprovalFontColor(projectColor)}
                    />
                    <Radio
                        // isBook={isBook}
                        // disabled={buttonDisabled}
                        onChange={() => setSelected(NO)}
                        name={'approval'}
                        title={t('no')}
                        checked={selected === NO}
                        clr={getApprovalFontColor(projectColor)}
                    />
                </FlexBox>
                <FlexBox>
                    <div data-tip={'Выберите один из вариантов'}>
                        <ApproveProjectButton
                            // isBook={isBook}
                            onClick={handleSubmit}
                            disabled={false}
                        >
                            {t('save')}
                        </ApproveProjectButton>
                    </div>
                </FlexBox>
            </FlexBox>
            <ReactTooltip/>
        </ApprovalDialogWrapper>
    );
};

export default memo(OrganizationApprovalDialog)
